import type { BuckChatWelcomeContent } from '../../types';
import BaseEmptyState from './BaseEmptyState';

export const LISTING_EMPTY_STATE_DEFAULTS: BuckChatWelcomeContent = {
  heading: 'Have a question?',
  introBody:
    'I can answer questions about this property - species, seasons, rules, access, and more. What would you like to know?',
  starterPrompts: [
    { label: 'Property Rules', value: 'What are the property rules?' },
    { label: 'Cancellation Policy', value: 'What is the cancellation policy?' },
    {
      label: 'Available Property Amenities',
      value: 'What property amenities are available?',
    },
    {
      label: 'Available Lodging',
      value: 'What lodging options are available?',
    },
  ],
};

type ListingEmptyStateProps = {
  content?: BuckChatWelcomeContent;
  disabled?: boolean;
  onPromptClick?: (prompt: string) => void;
  starterPromptsTitle?: string;
};

const ListingEmptyState = ({ content }: ListingEmptyStateProps) => {
  return <BaseEmptyState content={content} defaultContent={LISTING_EMPTY_STATE_DEFAULTS} />;
};

export default ListingEmptyState;
